'use client';

import { useState } from 'react';

import { AppleIcon, GoogleIcon } from '@/components/icons/SocialProviderIcons';
import { Button } from '@/components/ui/button';
import { authClient } from '@/lib/auth-client';

const CALLBACK_URL = '/u/home';

export function SocialAuthButtons() {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [isAppleLoading, setIsAppleLoading] = useState(false);

  return (
    <div className="space-y-2">
      <Button
        type="button"
        variant="outline"
        disabled={isGoogleLoading || isAppleLoading}
        className="w-full border-gray-600 bg-gray-700 text-gray-200 hover:bg-gray-600"
        onClick={async () => {
          setIsGoogleLoading(true);
          await authClient.signIn.social({ provider: 'google', callbackURL: CALLBACK_URL });
          setIsGoogleLoading(false);
        }}>
        <GoogleIcon className="mr-2 size-4" />
        {isGoogleLoading ? 'Connecting...' : 'Continue with Google'}
      </Button>

      <Button
        type="button"
        variant="outline"
        disabled={isGoogleLoading || isAppleLoading}
        className="w-full border-gray-600 bg-gray-700 text-gray-200 hover:bg-gray-600"
        onClick={async () => {
          setIsAppleLoading(true);
          await authClient.signIn.social({ provider: 'apple', callbackURL: CALLBACK_URL });
          setIsAppleLoading(false);
        }}>
        <AppleIcon className="mr-2 size-4" />
        {isAppleLoading ? 'Connecting...' : 'Continue with Apple'}
      </Button>
    </div>
  );
}
